export default __webpack_public_path__ + "static/media/tavelGuru.84d15358.jpg";